// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"180ae94d","178":"121de6a1","227":"194237b3","370":"355f5168","453":"5172ef91","610":"9f4649f9","971":"366293a6"}[chunkId] + ".chunk.js";
};